<template>
    <div class="column">
        <div class="dishes">
            <Dish
                :code="dish.code"
                :name="dish.name"
                :description="dish.description"
                :price="dish.price"
                v-for="(dish, index) in this.currentDishes" :key="index"
            />
        </div>
        <Pagination
            :refresh="this.refresh"
            :size="this.size"
            @changePage="this.renderDishes"
        />
    </div>
</template>

<script>
import Dish from '@/components/menu/Dish'
import Pagination from '@/components/menu/Pagination'
export default {
    props: ['dishes'],
    components: {
        Dish,
        Pagination
    },
    watch: {
        // Watch for category change
        dishes: function() {
            this.refresh = true
        }
    },
    computed: {
        size: function() {
            return Math.ceil(this.dishes.length / this.pageSize)
        },
    },
    methods: {
        // Render dishes according to page number
        renderDishes(n) {
            this.refresh = false
            let start = (n > 0 ? (n * this.pageSize) : n)
            let end = (n > 0 ? ((n + 1) * this.pageSize) : this.pageSize)

            this.currentDishes = this.dishes.slice(start, end)
        },
    },
    data() {
        return {
            refresh: false,
            pageSize: 4,
            currentDishes: this.dishes.slice(0,4)
        }
    }
}
</script>

<style lang="scss" scoped>
    .column {
        background: #fff;
        border: 1px solid #bdc3c7;
        width: 70%;
        padding: .3rem;
        .dishes{
            height: 450px;
        }
    }

@media screen and (max-width: 600px) {
    .column{
        width: 100%;
        padding: 0;
        height: 540px;
        .dishes{
            height: 420px;
        }
    }
}
</style>
